// FormStepContext.tsx
import { createContext, useContext } from "react";

export const FormStepContext = createContext<number>(0); // default to step 0
export const useFormStep = () => useContext(FormStepContext);